import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const PasswordField = ({ InputProps, inputProps, inputRef, ...props }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const innerInputRef = useRef(null);
  const toggleLabel = visible
    ? t("auth.hidePassword")
    : t("auth.showPassword");
  const setInputRef = (node) => {
    innerInputRef.current = node;

    if (typeof inputRef === "function") {
      inputRef(node);
    } else if (inputRef) {
      inputRef.current = node;
    }
  };
  const handleToggleVisibility = () => {
    const input = innerInputRef.current;
    const selection = input
      ? {
          start: input.selectionStart,
          end: input.selectionEnd,
          direction: input.selectionDirection,
        }
      : null;

    setVisible((current) => !current);

    window.requestAnimationFrame(() => {
      if (
        !selection ||
        !innerInputRef.current ||
        !Number.isInteger(selection.start) ||
        !Number.isInteger(selection.end)
      ) {
        return;
      }

      innerInputRef.current.focus();
      innerInputRef.current.setSelectionRange(
        selection.start,
        selection.end,
        selection.direction || "none"
      );
    });
  };

  return (
    <TextField
      {...props}
      type={visible ? "text" : "password"}
      inputRef={setInputRef}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            {InputProps?.endAdornment}
            <IconButton
              aria-label={toggleLabel}
              edge="end"
              onClick={handleToggleVisibility}
              onMouseDown={(event) => event.preventDefault()}
            >
              {visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      inputProps={{
        ...inputProps,
        "aria-label": props.label,
      }}
    />
  );
};

export default PasswordField;
